module.exports = __webpack_public_path__ + "static/media/m_eyebrowshape_hardangled_vector.6f4f7de2.svg";